/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState,useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userActivation, isLinkValid, login, reset_password, UserDetails } from '../../redux/actions/authActions';
import { TextField, Button, CircularProgress, Alert, Container, Box, Typography } from '@mui/material';
import Loading from '../Loading';
import PageLoaderComp from '../pageLoaderComp';
import { Navigate, useNavigate,Link,useParams   } from 'react-router-dom';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from '@mui/material/IconButton';
import './Styles.scss';

const ActivateAccountComp = () => {
  const [isValid, setIsValid] = useState(false);
  const [messageRes, setMessageRes] = useState("");
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { loading,pageloading, error,message,user,isLoggedIn,auth_token } = useSelector((state) => state.auth);
 
  useEffect(() => {
    const validateLink = async () => {
        const data = await dispatch(userActivation(params.activatekey));
        console.log("validateLink",data); // Use the returned data
        setIsValid(data.success);
        if(data.success){
          setMessageRes(data.message);
        }
        // setMessageRes(data.message);
    };
    validateLink();
}, [params.activatekey, dispatch]);
 
  return (
      
    <Box>
        {
            pageloading?<PageLoaderComp />:""
        }
        
        <Box
        className="loginMain"
        >
          <Box className="loginBoxInn">
            <Typography component="h1" variant="h4" mb={2}>
                Thank you!
            </Typography>
            <Typography component="h5" variant="h5" mb={2}>
                {messageRes}
            </Typography>
            
            {/* <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              >
              {loading ?  <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Login'}
              </Button> */}
              <Box textAlign={"center"} style={{ color: '#8BAF91' }}>
                <Link to="/login" style={{ color: '#8BAF91' }} variant="body2">
                    Back to Login
                </Link>
              </Box>
            </Box>
        </Box>
    </Box>
  );
};

export default ActivateAccountComp;
